import marketChangePrice from '@/components/market/market-change-price/market-change-price.vue';
import loaderMixin from '@/mixins/loader';
import { isMarketSingle } from '@/utils/helpers';

function getPriceOrZero(target) {
  // value may be empty or can come as fraction like 0.99 or 99
  if (isNaN(target)) return 0;
  return target < 1 ? Math.round(100 * target) : Math.round(target);
}

function hasPrice(target) {
  return getPriceOrZero(target) > 0;
}

export default {
  mixins: [loaderMixin],
  props: {
    widget: Object,
    theme: {
      type: String,
      default: '',
    },
  },
  components: {
    marketChangePrice,
  },
  computed: {
    classModifiers() {
      return {
        'market-money-widget': true,
        [`market-money-widget--${this.theme}`]: this.theme,
      };
    },
    iconModifiers() {
      return {
        'market-money-widget__icon': true,
        [`market-money-widget__icon--${this.iconTargetClass}`]: this.iconTargetClass,
      };
    },
    iconTargetClass() {
      return this.delta ? 'price-up' : 'price-down';
    },
    obj() {
      return this.widget ? this.widget : {};
    },
    hasPrice() {
      return hasPrice(this.obj.lastTradePrice);
    },
    price() {
      return getPriceOrZero(this.obj.lastTradePrice);
    },
    delta() {
      if (!this.hasPrice) {
        return 0;
      }
      return getPriceOrZero(this.obj.lastTradePrice) - getPriceOrZero(this.obj.lastClosePrice);
    },
    percent() {
      const value = (this.obj.percentValue || '0').toString();
      if (value.endsWith('%')) {
        return value;
      }
      const parsed = Number.parseInt(value, 10);
      return isNaN(parsed) ? '0%' : `${parsed}%`;
    },
    contractName() {
      return isMarketSingle(this.obj) ? 'Latest Price' : this.obj.contractName;
    },
  },
  methods: {
    onClick() {
      this.$router.push({
        name: 'market-details',
        params: {
          marketId: this.obj.marketId,
          marketUrl: this.obj.marketUrl,
        },
      });
    },
  },
  watch: {
    widget(val) {
      if (val) {
        this.loaderRemove();
      }
    },
  },
  mounted() {
    if (!this.widget) {
      this.loaderAdd();
    }
  },
};
